var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"histogram-switch\" id=\"dynamic-histogram\" title=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"dynamic-histogram-title") || (depth0 != null ? lookupProperty(depth0,"dynamic-histogram-title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"dynamic-histogram-title","hash":{},"data":data,"loc":{"start":{"line":1,"column":60},"end":{"line":1,"column":87}}}) : helper)))
    + "\" aria-hidden=\"true\">\n  <label class=\"panel-title\">\n    <input type=\"checkbox\" name=\"\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"enableDynamicHistogram") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":35},"end":{"line":3,"column":79}}})) != null ? stack1 : "")
    + ">\n    <span></span>\n  </label>\n</div>\n<!-- \n<div id=\"dynamic-histogram\" class=\"control ${this.enableDynamicHistogram === true ? 'active' : ''}\" title=\"${i18next.t('dynamic-histogram-title')}\"><i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i></div> -->";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/core/views/TimeSliderHistogramButton.hbs
// module id = 2035
// module chunks = 0